import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { campaignSelector, campaignWasLoadedSelector } from '../../../../../../modules/selectors/campaigns'
import { clearCampaign, getCampaign } from '../../../../../../modules/actions/campaigns'

import { OUTCOME_APP_PROMOTION } from '../../../../../../constants/campaigns'
import { FACEBOOK_PLATFORM } from '../../../../../../constants/selectLists/platformList'

export function useOutcomeAppPromotionCampaign({ facebookAdAccountId, campaignId, campaignObjective }) {
  const dispatch = useDispatch()

  const campaignDetails = useSelector(campaignSelector)
  const campaignDetailsWasLoaded = useSelector(campaignWasLoadedSelector)

  const isIos14Campaign = campaignDetails?.ios14

  // If campaign objective is app promotion - we need to fetch campaign data to get 'ios14' field
  const isOutcomeAppPromotionCampaign = campaignObjective === OUTCOME_APP_PROMOTION

  const showPromotedObjectStepForAppPromotionCampaign = useMemo(() => {
    return isOutcomeAppPromotionCampaign && !isIos14Campaign
  }, [isOutcomeAppPromotionCampaign, isIos14Campaign])

  const isDataLoading = isOutcomeAppPromotionCampaign ? !campaignDetailsWasLoaded : false

  useEffect(() => {
    if (isOutcomeAppPromotionCampaign) {
      // If campaign objective is app promotion - we need to fetch campaign data to get 'ios14' field
      dispatch(
        getCampaign(
          {
            account: facebookAdAccountId,
            id: campaignId
          },
          FACEBOOK_PLATFORM
        )
      )
    }
  }, [dispatch, campaignId, isOutcomeAppPromotionCampaign, facebookAdAccountId])

  useEffect(() => {
    return () => {
      if (isOutcomeAppPromotionCampaign && campaignDetailsWasLoaded) {
        dispatch(clearCampaign())
      }
    }
  }, [dispatch, campaignDetailsWasLoaded, isOutcomeAppPromotionCampaign])

  return {
    showPromotedObjectStepForAppPromotionCampaign,
    isDataLoading,
    isIos14Campaign
  }
}
